import { IInventoryPage } from '../../../inventory-page.interface';


export const RESEARCH_KEYWORD_KW_WORKBENCH_PAGE: IInventoryPage = {
	'route': '/research/keyword/kw-workbench',
	'title': 'KW Workbench',
	'uiReference': [
		'Keyword editors',
		'Editor actions',
		'Editor content totals',
		'characters',
		'words',
		'keywords',
		'Containing Word / Phrase',
		'Protected Characters',
		'Old',
		'New',
		'Combine By',
		'Increase Number',
		'Transform',
		'Actions',
		'Select one or more',
		'Extract Keywords from Text',
		'Language:',
		'Remove Duplicates',
		'Remove Containing',
		'Remove Common Words',
		'Remove Unwanted Words',
		'Remove Numbers',
		'Remove Single Letters',
		'Remove ASIN',
		'Remove Special Chars',
		'Replace',
		'Combine Word',
		'Letter case',
		'Text formatting',
		'Keep Original',
		'Title Case',
		'UPPER CASE',
		'lower case',
		'Sequence',
		'Sorting',
		'Alphabetic',
		'Occurrence',
		'Character Length',
		'Random / Shuffle',
		'Sorting order',
		'Ascending',
		'Descending',
		'Structure',
		'Grouping',
		'No Grouping',
		'By Single / Phrase',
		'By Word Count',
		'Separated Char',
		'Delivery',
		'Output formatting',
		'Comma with Space',
		'Only Space',
		'Separate by',
		'One per Line'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-workbench/kw-workbench-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-workbench/kw-workbench-page/kw-workbench-page.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-workbench/kw-workbench-page/kw-workbench-page.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-workbench/shared/workbench-input-field/workbench-input-field.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-workbench/shared/workbench-input-field/workbench-input-field.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-workbench/shared/workbench-options/action-options/action-options.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-workbench/shared/workbench-options/action-options/action-options.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-workbench/shared/workbench-options/text-format-options/text-format-options.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-workbench/shared/workbench-options/text-format-options/text-format-options.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-workbench/shared/workbench-options/sort-options/sort-options.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-workbench/shared/workbench-options/sort-options/sort-options.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-workbench/shared/workbench-options/group-options/group-options.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-workbench/shared/workbench-options/group-options/group-options.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-workbench/shared/workbench-options/output-format-options/output-format-options.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-workbench/shared/workbench-options/output-format-options/output-format-options.component.html'
	],
	'aliases': []
};
